module.exports = __webpack_public_path__ + "img/UTBEAR-2.4082387c.jpg";